var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avoid-page-break"},[_c('TestRow',{staticClass:"avoid-page-break",attrs:{"id":"64","profileTest":_vm.profileTest,"name":"Working Memory"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }